export default __webpack_public_path__ + "static/media/logoMof.77d629a4.svg";